var l = Object.defineProperty;
var o = (a, t, e) => t in a ? l(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var r = (a, t, e) => o(a, typeof t != "symbol" ? t + "" : t, e);
class i {
  constructor(t) {
    r(this, "instance");
    this.instance = t;
  }
  async getChannelData({
    collection: t,
    objectId: e,
    channelId: n
  }) {
    const s = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/objects/${t}/${e}/channel_data/${n}`
    });
    return this.handleResponse(s);
  }
  async setChannelData({
    objectId: t,
    collection: e,
    channelId: n,
    data: s
  }) {
    const c = await this.instance.client().makeRequest({
      method: "PUT",
      url: `v1/objects/${e}/${t}/channel_data/${n}`,
      data: { data: s }
    });
    return this.handleResponse(c);
  }
  handleResponse(t) {
    if (t.statusCode === "error")
      throw new Error(t.error || t.body);
    return t.body;
  }
}
export {
  i as default
};
//# sourceMappingURL=index.mjs.map
